export default __webpack_public_path__ + "static/media/logo-gemina-procesos-alimentarios.35a5baf4.svg";